<template lang="pug" src="./layout.pug"></template>
<style rel="stylesheet/scss" lang="scss" src="./layout.scss"></style>

<script>
import Vue from 'vue'
import ResizeMixin from './mixin/ResizeHandler'
import alerts from '@/components/VueAlerts'
import request from '@/utils/request'
import debounce from 'debounce'

import { mapState, mapGetters } from 'vuex'

export default {
	name: 'Layout',
	components: {
		'v-alerts': alerts
	},
	mixins: [ResizeMixin],
	data: () => ({
		drawer: null,
		currentLang: '',
		locales: [],
		centerCoords: null,
		data: null,
		isLoading: false
	}),
	computed: {
		...mapGetters([
			'loggedIn',
			'isMobileDevice'
		]),
		...mapState({
			cities: state => state.app.cities,
			defaultCity: state => state.app.defaultCity,
			order: state => state.api.order,
			showClose: state => state.app.showClose,
			language: state => state.app.language,
			countryCode: state => state.app.countryCode,
			reverse: state => state.api.reverseIndex
		}),
		canChangeCity: function() {
			return !this.order || !this.order.orderId
		},
		dataText() {
			return this.data && this.data.description || this.$vuetify.t(`$vuetify.pages.Dashboard.continueSearch`)
		}
	},
	watch: {
		isMobileDevice: function(value) {
			this.disableMap(value)
		},
		language: function(value) {
			this.changeLocale(value)
		},
		reverse: function(newVal, oldVal) {
			this.disableMap(!newVal)

			if (!oldVal && newVal && !this.data) {
				this.reverseGeocode()
			}

			if (oldVal && !newVal) {
				this.data = null
			}
		}
	},
	created: function() {
		this.currentLang = this.$vuetify.lang.current
		this.locales = Object.keys(this.$vuetify.lang.locales)

		if (this.language != this.currentLang) {
			this.changeLocale(this.language)
		}
	},
	mounted: function() {
		const coords = this.defaultCity ? [this.defaultCity.lat, this.defaultCity.lon] : [48.3830, 31.1829]
		this.map = window.L.map('map').setView(coords, this.defaultCity && this.defaultCity.defaultZoom || 13)

		window.L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
			attribution: '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap contributors</a>'
		}).addTo(this.map)

		this.map.on('dragend', this.reverseGeocode)
		this.map.on('zoomend', this.reverseGeocode)
	},
	methods: {
		hideFrame: function(event) {
			window.top.postMessage('closeFrame', document.referrer)
		},

		changeLocale: function(lang) {
			if (this.locales.includes(lang)) {
				this.currentLang = lang
				this.$vuetify.lang.current = lang
				this.$store.commit('SET_LANGUAGE', lang)
			}
		},

		changeDefaultCity: function(city) {
			this.$store.commit('SET_DEFAULT_CITY', city)

			if (city.lat && city.lon) {
				this.map.setView([city.lat, city.lon], city.defaultZoom || 13)
			}

			if (this.loggedIn) {
				this.$store.dispatch('getTariffs')
				this.$store.dispatch('getOptions')
			}
		},

		logout: async function() {
			await this.$store.dispatch('logout')
			this.$router.push('/login')
		},

		search: debounce(function() {
			if (this.isLoading) return

			if (!this.defaultCity || !this.defaultCity.code) {
				return this.$store.dispatch('getCities')
			}

			this.isLoading = true

			request({
				method: 'get',
				url: `${this.countryCode}${this.defaultCity.code}/places/reverse`,
				params: {
					lat: this.centerCoords.lat,
					lon: this.centerCoords.lng,
					lang: this.$vuetify.lang.current
				}
			}).then(res => {
				if (res && res.data && res.status == 200) {
					return this.data = Vue.filter('extendAddress')(res.data)
				}

				this.data = null
			}).catch(_ => {
				this.data = null
			}).finally(() => {
				this.isLoading = false
			})
		}, 500),

		reverseGeocode() {
			if (!this.reverse) return

			this.centerCoords = this.map.getCenter()
			this.search()
		},

		closeReverse() {
			this.$store.commit('CHANGE_REVERSE_INDEX', null)
		},

		saveReverse() {
			if (this.data) {
				this.$store.commit('SET_REVERSE_DATA', this.data)
			}

			this.closeReverse();
		},

		disableMap(value) {
			const func = value ? 'disable' : 'enable'

			this.map.dragging[func]()
			this.map.touchZoom[func]()
			this.map.doubleClickZoom[func]()
			this.map.scrollWheelZoom[func]()
		}
	}
}
</script>
